/*
 * <kremi-share> — ürün sayfasında başlığın yanındaki paylaş ikonu.
 *
 * Markup: snippets/kremi-share-button.liquid
 *
 * İki yol var, cihaza göre seçilir:
 *   1. `navigator.share` varsa (mobil tarayıcılar, Safari) SİSTEM paylaşım sayfası açılır.
 *      Kullanıcının WhatsApp/mesaj/not alışkanlığı oradan çıkar — biz kanal seçmeyiz.
 *   2. Yoksa (ör. Chrome/macOS) ürün linki panoya kopyalanır ve kısa bir balon belirir.
 *
 * Eleman markup'ta `hidden` doğar ve burada AÇILIR: bu dosya yüklenmezse ya da iki yol da
 * kullanılamıyorsa (eski tarayıcı, güvensiz köken) tıklayınca hiçbir şey yapmayan bir ikon
 * kalmasın. Panoya yazma yalnız HTTPS/localhost'ta çalışır — kaynak güvensizse buton hiç
 * çıkmaz, yanlış "kopyalandı" mesajı verilmez.
 */
(function () {
  if (window.customElements.get('kremi-share')) {
    return;
  }

  var TOAST_MS = 1600;

  var KremiShare = class extends HTMLElement {
    connectedCallback() {
      this._canNativeShare = typeof navigator.share === 'function';
      this._canCopy = !!(navigator.clipboard && window.isSecureContext);

      if (!this._canNativeShare && !this._canCopy) {
        return; // hidden kalır
      }

      this.hidden = false;
      this._onClick = this.onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this._onClick) {
        this.removeEventListener('click', this._onClick);
      }
      if (this._toastTimer) {
        clearTimeout(this._toastTimer);
      }
    }

    get url() {
      return this.getAttribute('data-url') || window.location.href;
    }

    onClick(event) {
      if (!event.target.closest('.kremi-share__button')) {
        return;
      }

      if (this._canNativeShare) {
        navigator
          .share({ title: this.getAttribute('data-title') || document.title, url: this.url })
          // Kullanıcı paylaşım sayfasını kapatınca reddedilir — hata değil, sessiz geç.
          .catch(function () {});
        return;
      }

      var self = this;
      navigator.clipboard.writeText(this.url).then(
        function () {
          self.showToast();
        },
        function () {
          // Pano reddedilirse (izin/odak) sessiz kal: yanlış onay verme.
        }
      );
    }

    showToast() {
      var toast = this.querySelector('.kremi-share__toast');
      if (!toast) {
        return;
      }

      toast.textContent = this.getAttribute('data-copied-label') || 'Kopyalandı';
      this.setAttribute('data-copied', '');

      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(
        function () {
          this.removeAttribute('data-copied');
        }.bind(this),
        TOAST_MS
      );
    }
  };

  window.customElements.define('kremi-share', KremiShare);
})();
